import { ExternalLinks } from '@/constants/global';
import { ROUTES } from '@/router';
import { UserRole } from '@/types';

type NavLinks = {
  title: string;
  target: string;
  external?: boolean;
  hidden?: boolean;
};

type Config = {
  allowedToViewSalesResources: boolean;
  allowedToViewWorkRamp: boolean;
  role: UserRole;
  companyPricing: boolean;
  newManageUsers: boolean;
};

export const getNavLinkConfig = (config: Config): NavLinks[] => {
  const links: NavLinks[] = [
    {
      title: 'My Dashboard',
      target: ROUTES.Private.Dashboard.ActivityList,
    },
    {
      title: 'Company Profile',
      target: ROUTES.Private.Profile.View,
    },
    {
      title: 'Installer Training',
      target: ExternalLinks.LearningCenter,
      external: true,
    },
  ];

  if (config.allowedToViewWorkRamp) {
    links.push({
      title: 'Sales Training',
      target: 'workramp',
      external: true,
    });
  }

  if (config.allowedToViewSalesResources) {
    links.push({
      title: 'Marketing Materials',
      target: ExternalLinks.MarketingMaterials,
      external: true,
    });
  }

  links.push({
    title: 'Typeform Site Survey',
    target: ExternalLinks.TypeForm,
    external: true,
    hidden: true,
  });

  if (config.role === UserRole.Admin) {
    links.push({
      title: config.newManageUsers ? 'Manage Users' : 'Manage User Permissions',
      target: ROUTES.Private.ManageUsers,
    });

    if (config.companyPricing) {
      links.push({
        title: 'Account Settings',
        target: ROUTES.Private.AccountSettings,
      });
    }
  }

  return links;
};
